const __WEBPACK_NAMESPACE_OBJECT__ = require("@oraichain/service-provider-orai");